// @ts-strict-ignore
import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

export class DataDefinitionsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}) {
    return appApiUrl(`data-definitions`, {projectId, workspaceId});
  }

  processResponse(response, _params) {
    return response.results;
  }
}
